import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import getGqlClient from '@spotahome/marketplace-common/src/graphql/client';
import getReviews from '@spotahome/marketplace-common/src/graphql/queries/reviews';

import { ListingSectionObservable } from '../ListingSection';
import ListingTitle from '../ListingTitle';

import './Reviews.scss';
import Average from './Average';
import ReviewsFactors from './ReviewsFactors';
import ListingReviews from './ListingReviews';

class Reviews extends Component {
  static propTypes = {
    reference: PropTypes.string.isRequired
  };

  state = {
    reviews: [],
    average: [],
    totalAverage: 0
  };

  async componentDidMount() {
    try {
      const response = await getReviews(getGqlClient())(this.props.reference);
      const reviews = response.data.reviews;
      if (reviews) {
        this.setState(reviews);
      }
    } catch (error) {
      console.error(error);
    }
  }

  render() {
    return (
      <ListingSectionObservable section="reviews">
        <ListingTitle role="secondary">
          {trans('listing.reviews.title')}
        </ListingTitle>
        <div id="reviews">
          {!!this.state.totalAverage && (
            <Fragment>
              <Average
                ratingAverage={Math.round(this.state.totalAverage)}
                count={this.state.reviews.length}
              />
              <ReviewsFactors factors={this.state.average} />
            </Fragment>
          )}
          <ListingReviews reviews={this.state.reviews} />
        </div>
      </ListingSectionObservable>
    );
  }
}

export default Reviews;
